import { companionsFor } from "@/lib/gardenChecks";
import { HeartHandshake, Ban, Ruler } from "lucide-react";

function Chips({ items, tone, testId }) {
  if (!items.length) return <span className="text-xs text-muted-foreground">none listed</span>;
  return (
    <div className="flex flex-wrap gap-1" data-testid={testId}>
      {items.map((v) => (
        <span key={v.slug} className={`inline-flex items-center gap-1 rounded-full pl-0.5 pr-2 py-0.5 text-[11px] font-medium ${tone}`}>
          <img src={v.icon} alt="" className="h-4 w-4 object-contain" /> {v.name}
        </span>
      ))}
    </div>
  );
}

export function CompanionHint({ veg, catalog }) {
  if (!veg) return null;
  const { good, bad } = companionsFor(veg, catalog);
  return (
    <div className="mt-2 rounded-xl border border-border bg-muted/40 p-2.5 grid gap-2 sm:grid-cols-[auto_1fr_1fr] sm:items-start animate-rise" data-testid="companion-hint">
      <div className="flex items-center gap-2 sm:pr-3">
        <img src={veg.icon} alt="" className="h-8 w-8 object-contain" />
        <div>
          <p className="text-sm font-semibold leading-tight">{veg.name}</p>
          {veg.spacing_cm ? (
            <p className="text-[11px] text-muted-foreground flex items-center gap-1" data-testid="companion-hint-spacing"><Ruler className="h-3 w-3" /> ~{veg.spacing_cm}cm apart</p>
          ) : null}
        </div>
      </div>
      <div>
        <p className="text-[11px] font-semibold text-emerald-700 dark:text-emerald-400 flex items-center gap-1 mb-1"><HeartHandshake className="h-3 w-3" /> Good neighbours</p>
        <Chips items={good} tone="bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300" testId="companion-hint-good" />
      </div>
      <div>
        <p className="text-[11px] font-semibold text-rose-700 dark:text-rose-400 flex items-center gap-1 mb-1"><Ban className="h-3 w-3" /> Keep apart</p>
        <Chips items={bad} tone="bg-rose-100 text-rose-800 dark:bg-rose-900/40 dark:text-rose-300" testId="companion-hint-bad" />
      </div>
    </div>
  );
}
